<template>
  <div class="header-top">
    <div id="app-main-header">
      <!-- Hamburger menu -->
      <div class="main-header-lhs">
        <div class v-if="showDropDown">
          <hamburger-menu-vue />
        </div>

        <!-- Logo -->
        <div class="col-6-custom username-top">
          <logo-icon-vue />
        </div>
      </div>

      <!-- Username -->
      <div class="main-header-username">
        <span @click="toggleShowPermittedListDropDown"> {{ username }} </span>

        <!-- Drop Down menu -->
        <transition name="zoom">
          <div
            class="dropdown"
            v-if="permittedUser.length > 1 && showPermittedListDropDown"
          >
            <div>
              <ul>
                <li
                  v-for="user in permittedUser"
                  :key="user.id"
                  :value="user.id"
                  @click="changeProviderLocal(user.id)"
                >
                  {{
                    formatName(
                      user.firstName,
                      user.middleName,
                      user.lastName,
                      user.namePrefix,
                      user.nameSuffix,
                      user.credentials,
                      "heading"
                    )
                  }}
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>

      <!-- Logout icon -->
      <div class="main-header-rhs">
        <a href="#" class="logout-link" @click.stop.prevent="localLogout">
          <img :src="lockIcon" />
        </a>
      </div>
    </div>

    <!-- Logout button -->
    <div class="clear"></div>
  </div>
</template>

<script>
import HamburgerMenuVue from "../Appointment/common/HamburgerMenu";
import LogoIconVue from "../Appointment/common/LogoIcon.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { nameMixin } from "../../mixins/nameMixin.js";
import { permissionMixin } from "../../mixins/permissionMixin";

export default {
  mixins: [nameMixin, permissionMixin],
  data() {
    return {
      showPermittedListDropDown: false
    };
  },
  computed: {
    ...mapGetters({
      userDetails: "getUserDetails", // Gets the user details
      permittedUser: "getPermittedUser", // Gets the list of permitted users
      selectedProviderID: "getSelectedProviderID" // Get the currently selected provider
    }),
    lockIcon() {
      return require("../../assets/img/lock-icon.jpg");
    },
    /**
     * Username to show to the user
     */
    username() {
      const {
        firstName,
        middleName,
        lastName,
        namePrefix,
        nameSuffix,
        credentials
      } = this.userDetails;
      return this.formatName(
        firstName,
        middleName,
        lastName,
        namePrefix,
        nameSuffix,
        credentials,
        "heading"
      );
    }
  },
  components: {
    LogoIconVue,
    HamburgerMenuVue
  },
  methods: {
    ...mapMutations({
      changeSelectedProviderID: "changeSelectedProviderID" //Change the currently selected provider id for app users
    }),
    ...mapMutations("group", {
      clearGroupSelected: "clearSelected"
    }),
    ...mapMutations("addNew", {
      clearInsuranceDetails: "clearInsuranceDetails"
    }),
    ...mapActions({
      logout: "logout"
    }),
    ...mapActions("addNew", { getInsuranceDetails: "getInsuranceDetails" }),
    localLogout() {
      this.logout(); // Sending logout request to server where the session is deleted
    },
    /**
     * Changes the currently selected provider id
     */
    changeProviderLocal(id) {
      this.changeSelectedProviderID(id);
      this.clearGroupSelected(); // Clear members selected for a  group
      this.clearInsuranceDetails(); // Clear the insurance selected
      if (this.$route.name === "AddClient") {
        this.getInsuranceDetails(); // Fetch the insurance company details only id it is the correct route
      }
    },
    /**
     * Toggle show drop down
     */
    toggleShowPermittedListDropDown() {

      // On appointment details and add appointment page, this name should not get changed.
      if(
        'AppointmentDetail' === this.$router.currentRoute.name || 
        'Add' === this.$router.currentRoute.name
      ) {
        return false;
      }

      const value = this.showPermittedListDropDown;
      setTimeout(() => {
        this.showPermittedListDropDown = !value;
      });
    },
    windowClickListener() {
      this.showPermittedListDropDown = false;
    }
  },
  /**
   * Add event listeners
   */
  mounted() {
    window.addEventListener("click", this.windowClickListener);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.windowClickListener);
  }
};
</script>

<style scoped>
select {
  font-size: 16px;
  font-weight: bold;
  line-height: 31px;
  background-color: black;
  color: white;
  width: 130%;
  overflow: hidden;
  padding: 8px 5px;
  border: 2px solid white;
  outline: none;
}

option {
  background-color: #f7f7f7;
  color: grey;
  border-bottom: 1px solid lightgray;
}
.header-top-right {
  float: right;
  padding: 10px 0 0 0;
}
.clear {
  clear: both;
}
.username-text {
  display: inline-block;
  padding: 4px 10px 0 0;
  font-weight: bold;
  vertical-align: middle;
}
.logout-link {
  display: inline-block;
  position:relative;
  left:10px;
}
.logout-link img {
  max-width: 20px;
}
#app-main-header {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.main-header-lhs {
  position: absolute;
  left: 0;
  width: 85px;
  z-index: 999;
}

.main-header-username {
  user-select: none;
  cursor: pointer;
  text-align: center;
  margin: 0 auto;
  line-height: 40px;
  font-weight: 600;
}

.main-header-username .dropdown {
  position: absolute;
  background-color: #f8f8f8;
  color: #333;
  top: 49px;
  left: 43.5%;
  box-shadow: 1px 1px 5px lightgrey;
  border-radius: 5px;
  padding: 0.2rem 1.5rem;
  border: 1px solid #d0d0d0;
  font-size: 16px;
  color: black;
  font-weight: 540;
}

.main-header-username .dropdown ul li[data-v-603f0264]:not(:last-of-type) {
  border-bottom: 1px solid #d0d0d0;
}

.main-header-rhs {
  position: absolute;
  right: 0;
  width: 35px;
  top: 8px;
  z-index: 999;
}

.zoom-enter-active {
  animation: zoomIn 0.5s ease-in-out;
}

.zoom-leave-active {
  animation: zoomOut 0.5s ease-in-out;
}

@keyframes zoomIn {
  from {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}
</style>
